import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

export function CustomQuestionsEditor({ questions = [], onChange }) {
  const set = (i, patch) => onChange(questions.map((q, idx) => (idx === i ? { ...q, ...patch } : q)));
  return (
    <section className="panel space-y-3 p-6" data-testid="custom-questions-editor">
      <div>
        <h3 className="text-base font-semibold">Application questions</h3>
        <p className="text-sm text-ink-secondary">Extra questions on the careers page, asked after the knockout questions.</p>
      </div>
      {questions.map((q, i) => (
        <div key={q.id || i} className="flex items-center gap-3" data-testid={`custom-question-row-${i}`}>
          <Input value={q.question} onChange={(e) => set(i, { question: e.target.value })} className="h-9 flex-1 text-sm" data-testid={`custom-question-${i}`} />
          <label className="flex items-center gap-2 text-xs text-ink-secondary">
            <Switch checked={!!q.required} onCheckedChange={(v) => set(i, { required: v })} data-testid={`custom-question-required-${i}`} /> Required
          </label>
          <button className="text-ink-muted hover:text-risk" aria-label="Remove question" onClick={() => onChange(questions.filter((_, idx) => idx !== i))}><Trash2 size={16} /></button>
        </div>
      ))}
      <Button variant="ghost" size="sm" className="text-brand" data-testid="custom-question-add-btn"
        onClick={() => onChange([...questions, { question: "", required: false }])}>
        <Plus size={14} /> Add question
      </Button>
    </section>
  );
}
